/**
 * WebComponent per lo zoom delle immagini prodotto
 */
class CmpProductImageZoom extends HTMLElement {
	constructor() {
		super();
		this.isInitialized = false;
		this.isLoading = false;
		
		this.triggerSelector = this.getAttribute('trigger-selector') || '.swiper-slide.gallery-slide';
		this.enableLogs = this.getAttribute('enable-logs') === 'true';
		
		// Zoom state
		this.currentZoom = 1;
		this.minZoom = 1;
		this.maxZoom = 5;
		this.panX = 0;
		this.panY = 0;
		
		// Interaction state
		this.isDragging = false;
		this.isZooming = false;
		this.startX = 0;
		this.startY = 0;
		
		// Touch handling
		this.touches = [];
		this.lastDistance = 0;
		
		// DOM references
		this.zoomContainer = null;
		this.currentImage = null;
		
		// Event cleanup
		this.boundPanEvents = {};	}
	log(message, data = null) {
		if (this.enableLogs) {
			if (data) {
				console.log(`🔍 ${message}`, data);
			} else {
				console.log(`🔍 ${message}`);
			}
		}	}

	warn(message, data = null) {
		if (this.enableLogs) {
			if (data) {
				console.warn(`🔍 ${message}`, data);
			} else {
				console.warn(`🔍 ${message}`);
			}
		}	}

	error(message, data = null) {
		if (data) {
			console.error(`🔍 ${message}`, data);
		} else {
			console.error(`🔍 ${message}`);
		}	}	connectedCallback() {
		if (this.isInitialized) return;
		this.isInitialized = true;
		
		const handleZoomTrigger = (event) => {
			const gallerySlide = event.target.closest(this.triggerSelector);
			
			if (gallerySlide) {
				event.preventDefault();
				
				const mediaId = gallerySlide.dataset.zoomId;
				const handle = this.extractProductHandle();
				const variantId = this.extractVariantId();
							if (!handle) {
					this.error('ProductImageZoom: Handle del prodotto non trovato');
					return;
				}

				if (!variantId) {
					this.warn('ProductImageZoom: ID della variante non trovato, continuo senza variante');
				}
				
				if (!mediaId) {
					this.error('ProductImageZoom: ID del media non trovato nel data-zoom-id');
					return;
				}

				this.openZoom(handle, variantId, mediaId);
			}
		};		// Touch handling variables for reliable mobile detection
		let touchTriggered = false;
		let touchStartTime = 0;
		let touchStartElement = null;
		let touchStartX = 0;
		let touchStartY = 0;
		let touchMoved = false;
		
		const SWIPE_THRESHOLD = 10;
		const TAP_MAX_DURATION = 500;		
		// Touch event listeners
		document.addEventListener('touchstart', (event) => {
			if (event.touches.length === 1) {
				touchStartTime = Date.now();
				touchStartElement = event.target.closest(this.triggerSelector);
				touchStartX = event.touches[0].clientX;
				touchStartY = event.touches[0].clientY;
				touchMoved = false;
			}
		}, { passive: true });
		
		document.addEventListener('touchmove', (event) => {
			if (touchStartElement && event.touches.length === 1) {
				const currentX = event.touches[0].clientX;
				const currentY = event.touches[0].clientY;
				const deltaX = Math.abs(currentX - touchStartX);
				const deltaY = Math.abs(currentY - touchStartY);
				
				if (deltaX > SWIPE_THRESHOLD || deltaY > SWIPE_THRESHOLD) {
					touchMoved = true;
				}
			}
		}, { passive: true });		document.addEventListener('touchend', (event) => {
			if (event.changedTouches.length === 1 && touchStartElement) {
				const touchDuration = Date.now() - touchStartTime;
				const endElement = event.target.closest(this.triggerSelector);
				
				if (touchDuration < TAP_MAX_DURATION && 
					endElement === touchStartElement && 
					!touchMoved) {
					
					touchTriggered = true;
					
					const syntheticEvent = {
						target: event.target,
						type: 'touchend',
						preventDefault: () => event.preventDefault()
					};
					
					handleZoomTrigger(syntheticEvent);
					
					setTimeout(() => {
						touchTriggered = false;
					}, 300);
				}
				
				touchStartElement = null;
				touchStartTime = 0;
				touchStartX = 0;
				touchStartY = 0;
				touchMoved = false;
			}
		}, { passive: false });
		
		// Click listener for desktop and mobile fallback
		document.addEventListener('click', (event) => {
			if (touchTriggered) return;
			handleZoomTrigger(event);
		});	}
	async openZoom(handle, variantId, mediaId) {
		if (this.isLoading) return;
		this.isLoading = true;

		try {
			this.createLoadingOverlay();
			this.preloadMainImage(handle, mediaId);

			let url = `/products/${handle}?sections=helper-product-zoom`;
			if (variantId && variantId !== 'undefined' && variantId !== 'null') {
				url += `&variant=${variantId}`;
			}
			if (mediaId && mediaId !== 'undefined' && mediaId !== 'null') {
				url += `&media=${mediaId}`;
			}
			
			const response = await fetch(url);
			const data = await response.json();

			this.innerHTML = data['helper-product-zoom'];
			this.initializeFeatures(mediaId);
		} catch (error) {
			this.error('ProductImageZoom: Errore caricamento zoom:', error);
			this.innerHTML = `
                <div class="product-zoom-overlay">
                    <div class="product-zoom-content">
                        <div class="alert alert-danger m-4">Errore caricamento immagini</div>
                        <button type="button" class="product-zoom-close" aria-label="Chiudi">×</button>
                    </div>
                </div>
            `;
			document.body.style.overflow = 'hidden';
			this.querySelector('.product-zoom-close').addEventListener('click', () => this.closeZoom());
		}

		this.isLoading = false;	}	async preloadMainImage(handle, mediaId) {
		setTimeout(async () => {
			try {
				const response = await fetch(`/products/${handle}.js`);
				const product = await response.json();

				let targetMedia = product.media?.find(m => m.id == mediaId);
				if (!targetMedia && product.media?.length > 0) {
					targetMedia = product.media[0];
				}

				if (targetMedia?.src) {
					const imageUrl = this.getOptimizedImageUrl(targetMedia.src);
					const img = new Image();
					img.src = imageUrl;
				}
			} catch (error) {
				this.warn('Preload immagine fallito:', error);
			}
		}, 0);	}
	getOptimizedImageUrl(originalUrl) {
		if (!originalUrl) return originalUrl;

		const isMobile = window.innerWidth <= 767;
		let targetSize;

		if (isMobile) {
			const { width: screenWidth, height: screenHeight } = window.screen;
			const pixelRatio = window.devicePixelRatio || 2;
			const maxDimension = Math.max(screenWidth, screenHeight) * pixelRatio;
			targetSize = Math.min(maxDimension, 2048);
		} else {
			const maxDimension = Math.max(window.innerWidth, window.innerHeight);
			targetSize = Math.min(maxDimension * 1.5, 2560);
		}

		const baseUrl = originalUrl.split('?')[0];
		return `${baseUrl}?width=${targetSize}&height=${targetSize}&crop=center&format=webp`;	}	createLoadingOverlay() {
        requestAnimationFrame(() => {
            this.innerHTML = `
                <div class="product-zoom-overlay">
                    <div class="product-zoom-content">
                        <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden">Caricamento...</span>
                            </div>
                        </div>
                        <button type="button" class="product-zoom-close" aria-label="Chiudi">×</button>
                    </div>
                </div>
            `;
            
            this.querySelector('.product-zoom-close').addEventListener('click', () => this.closeZoom());

            setTimeout(() => {
                this.originalBodyOverflow = document.body.style.overflow;
                this.originalBodyStyleCssText = document.body.style.cssText;
                
                document.body.style.setProperty('overflow', 'hidden', 'important');
                document.body.style.setProperty('margin', '0', 'important');
                document.body.style.setProperty('padding', '0', 'important');
                
                document.body.classList.add('product-zoom-active');
                
                this.scrollBarMonitor = setInterval(() => {
                    if (document.body.style.overflow !== 'hidden') {
                        document.body.style.setProperty('overflow', 'hidden', 'important');
                    }
                }, 100);
            },150);
        });    }	initializeFeatures(mediaId) {
		this.overlay = this.querySelector('.product-zoom-overlay');
		this.closeBtn = this.querySelector('.product-zoom-close');
		this.thumbs = this.querySelectorAll('.product-zoom-thumb');
		this.mediaItems = this.querySelectorAll('.product-zoom-main-media');

		if (mediaId) {
			this.setActiveMediaById(mediaId);
		} else {
			this.setActiveMedia(0, false, true);
		}

		requestAnimationFrame(() => {		// Setup mobile backgrounds solo se necessario
		if (window.innerWidth <= 767) {
			this.setupMobileBackgrounds();
		}

		this.addEventListeners();

		if (this.closeBtn) this.closeBtn.focus();
		this.centerZoomedImageVertically();
		});	}	centerZoomedImageVertically() {
		const main = this.querySelector('.product-zoom-main');
		if (!main) return;
		
		const getActiveImg = () => main.querySelector('.product-zoom-main-media.show img');
		
		const performCentering = (img) => {
			if (main.offsetHeight === 0) {
				setTimeout(() => this.centerZoomedImageVertically(), 100);
				return false;
			}
			
			const mainHeight = main.clientHeight;
			let imgHeight = img.clientHeight || img.naturalHeight || img.offsetHeight;
			
			if (imgHeight <= 0) {
				const width = img.clientWidth || img.naturalWidth || img.offsetWidth;
				if (width > 0 && img.naturalWidth > 0 && img.naturalHeight > 0) {
					imgHeight = (width * img.naturalHeight) / img.naturalWidth;
				} else {
					imgHeight = mainHeight;
				}
			}
			
			if (imgHeight < mainHeight) {
				main.scrollTop = 0;
			} else {
				const newScrollTop = Math.max(0, (imgHeight - mainHeight) / 2);
				main.scrollTop = newScrollTop;
			}
			
			return true;
		};
		
		const img = getActiveImg();
		if (!img) return;
		
		if (img.complete && img.naturalHeight > 0) {
			performCentering(img);
			return;
		}
		
		const onLoad = () => {
			performCentering(img);
			img.removeEventListener('load', onLoad);
			img.removeEventListener('error', onLoad);
		};
		
		img.addEventListener('load', onLoad, { once: true });
		img.addEventListener('error', onLoad, { once: true });
		
		setTimeout(() => {
			performCentering(img);
		}, 2000);	}	setupMobileBackgrounds() {
		this.mediaItems.forEach((media) => {
			const img = media.querySelector('img');
			
			if (img?.src) {
				const optimizedUrl = this.getOptimizedImageUrl(img.src);
				
				media.innerHTML = '';
				
				media.style.backgroundImage = `url(${optimizedUrl})`;
				media.style.backgroundSize = 'cover';
				media.style.backgroundPosition = 'center center';
				media.style.backgroundRepeat = 'no-repeat';
				media.style.width = '100%';
				media.style.height = '100%';
				media.style.minWidth = '100%';
				media.style.minHeight = '100%';
				media.style.maxWidth = '100%';
				media.style.maxHeight = '100%';
				media.style.boxSizing = 'border-box';
				media.style.margin = '0';
				media.style.padding = '0';
			}
		});	}	handleGlobalKeydown(e) {
		if (!this.overlay) return;

		switch (e.key) {
			case 'Escape':
				e.preventDefault();
				this.closeZoom();
				break;
			case 'ArrowLeft':
			case 'ArrowRight':
				// Solo se il focus non è su un thumbnail (evita conflitti)
				if (!e.target.classList.contains('product-zoom-thumb')) {
					e.preventDefault();
					const currentIndex = Array.from(this.thumbs).findIndex(thumb => 
						thumb.classList.contains('active')
					);
					
					let newIndex;
					if (e.key === 'ArrowLeft') {
						newIndex = currentIndex > 0 ? currentIndex - 1 : this.thumbs.length - 1;
					} else {
						newIndex = currentIndex < this.thumbs.length - 1 ? currentIndex + 1 : 0;
					}
					
					this.setActiveMedia(newIndex, true);
				}
				break;
		}	}	addEventListeners() {
		this.boundGlobalKeydown = this.handleGlobalKeydown.bind(this);

		// Chiusura
		if (this.closeBtn) {
			this.closeBtn.addEventListener('click', () => this.closeZoom());
		}

		// Click su overlay per chiudere
		if (this.overlay) {
			this.overlay.addEventListener('click', (e) => {
				if (e.target === this.overlay) this.closeZoom();
			});
		}
		// Click e keyboard su thumbnails
		this.thumbs.forEach((thumb, index) => {
			if (!thumb.hasAttribute('role')) {
				thumb.setAttribute('role', 'button');
			}
			if (!thumb.hasAttribute('aria-label')) {
				thumb.setAttribute('aria-label', `Visualizza media ${index + 1}`);
			}
			
			thumb.addEventListener('click', () => this.setActiveMedia(index, true));
			thumb.addEventListener('mouseenter', () => this.setActiveMedia(index, false));
			thumb.addEventListener('keydown', (e) => this.handleThumbKeydown(e, index));
		});
		
		// Keyboard shortcuts globali
		document.addEventListener('keydown', this.boundGlobalKeydown);
		
		// Gestione resize per ri-centrare l'immagine quando cambia la dimensione della finestra
		this.boundWindowResize = this.handleWindowResize.bind(this);
		window.addEventListener('resize', this.boundWindowResize);
		
		// Inizializza panning e zoom
		this.initializePanAndZoom();}
	handleWindowResize() {
		if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
		
		this.resizeTimeout = setTimeout(() => {
			this.centerZoomedImageVertically();
		}, 150);
	}

	forceCenterImage() {
		if (!this.overlay || !this.overlay.style.display || this.overlay.style.display === 'none') {
			return;
		}
		this.centerZoomedImageVertically();	}
	setActiveMedia(index, withTransition = true, isInitial = false) {
		if (!this.thumbs || !this.mediaItems) return;

		const targetThumb = this.thumbs[index];
		const targetMedia = this.mediaItems[index];

		if (!targetThumb || !targetMedia) return;
		// Aggiorna thumbnails con gestione tabindex per keyboard navigation
		this.thumbs.forEach((thumb, i) => {
			const isActive = i === index;
			thumb.classList.toggle('active', isActive);
			thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
			// Solo il thumbnail attivo può ricevere tab focus (migliora UX keyboard)
			thumb.setAttribute('tabindex', isActive ? '0' : '-1');
		});
			// Aggiorna media principale - ottimizzato per inizializzazione
			if (isInitial) {
				// Imposta direttamente senza iterare su tutti gli elementi
				targetMedia.style.opacity = '1';
				targetMedia.style.pointerEvents = 'auto';
				targetMedia.classList.add('show');

				// Nascondi solo gli altri visibili
				this.mediaItems.forEach((media, i) => {
					if (i !== index && media.style.opacity !== '0') {
						media.style.opacity = '0';
						media.style.pointerEvents = 'none';
						media.classList.remove('show');
					}
				});		} else {
			// Comportamento normale per le transizioni
			this.mediaItems.forEach((media, i) => {
				const isActive = i === index;
				media.style.opacity = isActive ? '1' : '0';
				media.style.pointerEvents = isActive ? 'auto' : 'none';
				media.classList.toggle('show', isActive);
			});
		}
		// Focus su thumbnail se richiesto e se è navigazione keyboard
		if (withTransition && targetThumb) {
            targetThumb.focus();
        }

        // Reset zoom quando si cambia immagine (solo se non è inizializzazione)
        if (!isInitial && this.resetPanAndZoom) {
        	this.resetPanAndZoom();
        }
        
        // Centra l'immagine attiva dopo il cambio (solo se non è inizializzazione)
        if (!isInitial) {
        	setTimeout(() => {
        		this.centerZoomedImageVertically();
        	}, withTransition ? 50 : 0);
        }	}	handleThumbKeydown(e, currentIndex) {
		let newIndex = currentIndex;

		switch (e.key) {
			case 'ArrowUp':
			case 'ArrowLeft':
				e.preventDefault();
				newIndex = currentIndex > 0 ? currentIndex - 1 : this.thumbs.length - 1;
				break;
			case 'ArrowDown':
			case 'ArrowRight':
				e.preventDefault();
				newIndex = currentIndex < this.thumbs.length - 1 ? currentIndex + 1 : 0;
				break;
			case 'Enter':
			case ' ':
				e.preventDefault();
				this.setActiveMedia(currentIndex, true);
				return;
			case 'Home':
				e.preventDefault();
				newIndex = 0;
				break;
			case 'End':
				e.preventDefault();
				newIndex = this.thumbs.length - 1;
				break;
		}

		if (newIndex !== currentIndex) {
			this.setActiveMedia(newIndex, true);
		}	}	extractProductHandle() {
		const pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
		if (pathMatch) return pathMatch[1];

		const metaProduct = document.querySelector('meta[property="product:handle"]');
		if (metaProduct) return metaProduct.getAttribute('content');

		const productScript = document.querySelector('script[type="application/json"][data-product]');
		if (productScript) {
			try {
				return JSON.parse(productScript.textContent).handle;
			} catch (e) {
				this.warn('ProductImageZoom: Errore parsing JSON prodotto:', e);
			}
		}
		return null;	}	extractVariantId() {
		const variantInput = document.querySelector('input[name="id"], input[name="variant_id"]');
		if (variantInput?.value) return variantInput.value;

		const productScript = document.querySelector('script[type="application/json"][data-product]');
		if (productScript) {
			try {
				const productData = JSON.parse(productScript.textContent);
				
				if (productData.selected_or_first_available_variant) {
					return productData.selected_or_first_available_variant.id.toString();
				}
				
				if (productData.variants?.length > 0) {
					this.warn('ProductImageZoom: Nessuna variante selezionata, uso la prima disponibile');
					return productData.variants[0].id.toString();
				}
			} catch (e) {
				this.warn('ProductImageZoom: Errore parsing JSON prodotto per variante:', e);
			}
		}

		const metaVariant = document.querySelector('meta[property="product:variant:id"]');
		if (metaVariant) return metaVariant.getAttribute('content');

		const urlParams = new URLSearchParams(window.location.search);
		const variantParam = urlParams.get('variant');
		if (variantParam) return variantParam;

		const productData = this.extractProductData();
		if (productData?.id) {
			this.warn('ProductImageZoom: Impossibile trovare variant ID, uso product ID come fallback');
			return productData.id.toString();
		}

		return null;	}
	extractProductData() {
		const productScript = document.querySelector('script[type="application/json"][data-product]');
		if (productScript) {
			try {
				return JSON.parse(productScript.textContent);
			} catch (e) {
				this.warn('ProductImageZoom: Errore parsing JSON prodotto:', e);
			}
		}
		return null;
	}closeZoom() {
		// Ferma il monitoraggio della scrollbar
		if (this.scrollBarMonitor) {
			clearInterval(this.scrollBarMonitor);
			this.scrollBarMonitor = null;
		}

		// Ripristina stato originale del body
		if (this.originalBodyStyleCssText !== undefined) {
			document.body.style.cssText = this.originalBodyStyleCssText;
		} else {
			// Fallback se non abbiamo salvato lo stato originale
			document.body.style.removeProperty('overflow');
			document.body.style.removeProperty('margin');
			document.body.style.removeProperty('padding');
		}
		
		// Rimuovi classe di supporto CSS
		document.body.classList.remove('product-zoom-active');
		
		// Rimuovi event listeners globali
		document.removeEventListener('keydown', this.boundGlobalKeydown);
		if (this.boundWindowResize) {
			window.removeEventListener('resize', this.boundWindowResize);
		}
		if (this.resizeTimeout) {
			clearTimeout(this.resizeTimeout);
		}

		// Cleanup panning e zoom
		this.cleanupPanAndZoom();

		// Svuota contenuto
		this.innerHTML = '';

		// Reset stato
		this.isLoading = false;
		this.overlay = null;
		this.closeBtn = null;
		this.thumbs = null;
		this.mediaItems = null;
		this.originalBodyOverflow = undefined;
		this.originalBodyStyleCssText = undefined;
		this.scrollBarMonitor = null;
		this.boundGlobalKeydown = null;
		this.boundWindowResize = null;
		this.resizeTimeout = null;
		
		// Reset stato pan e zoom
		this.currentZoom = 1;
		this.panX = 0;
		this.panY = 0;
		this.isDragging = false;
		this.isZooming = false;
		this.touches = [];
		this.zoomContainer = null;
		this.currentImage = null;
		this.boundPanEvents = {};
	}/**
     * Attiva il media e il thumb tramite mediaId
     * @param {string|number} mediaId
     */    setActiveMediaById(mediaId) {
        if (!mediaId) {
            this.setActiveMedia(0, false, true);
            return;
        }
        
        const id = String(mediaId);
        let idx = Array.from(this.thumbs).findIndex(thumb => String(thumb.dataset.mediaId) === id);
        
        if (idx === -1) {
            this.error('ProductImageZoom: mediaId non trovato', { 
                cercatoMediaId: id,
                disponibili: Array.from(this.thumbs).map(t => t.dataset.mediaId)
            });
            idx = 0;
        }
          
        this.setActiveMedia(idx, false, true);    }

	initializePanAndZoom() {		// Trova il container delle immagini e l'immagine corrente
		this.zoomContainer = this.querySelector('.product-zoom-main');
		if (!this.zoomContainer) {
			this.warn('ProductImageZoom: container zoom non trovato');
			return;
		}

		// Setup stili CSS per panning
		this.zoomContainer.style.cursor = 'grab';
		this.zoomContainer.style.overflow = 'hidden';
		this.zoomContainer.style.position = 'relative';
				// Bind event handlers
		this.boundPanEvents = {
			mousedown: this.handlePanStart.bind(this),
			mousemove: this.handlePanMove.bind(this),
			mouseup: this.handlePanEnd.bind(this),
			wheel: this.handleWheel.bind(this),
			dblclick: this.handleDoubleClick.bind(this),
			touchstart: this.handleTouchStart.bind(this),
			touchmove: this.handleTouchMove.bind(this),
			touchend: this.handleTouchEnd.bind(this)
		};
		// Event listeners per mouse (desktop)
		this.zoomContainer.addEventListener('mousedown', this.boundPanEvents.mousedown);
		document.addEventListener('mousemove', this.boundPanEvents.mousemove);
		document.addEventListener('mouseup', this.boundPanEvents.mouseup);
		this.zoomContainer.addEventListener('wheel', this.boundPanEvents.wheel, { passive: false });
		this.zoomContainer.addEventListener('dblclick', this.boundPanEvents.dblclick);
		// Event listeners per touch (mobile)
		this.zoomContainer.addEventListener('touchstart', this.boundPanEvents.touchstart, { passive: false });
		this.zoomContainer.addEventListener('touchmove', this.boundPanEvents.touchmove, { passive: false });
		this.zoomContainer.addEventListener('touchend', this.boundPanEvents.touchend);}	getCurrentImage() {
		if (!this.zoomContainer) return null;
		
		const img = this.zoomContainer.querySelector('.product-zoom-main-media.show img');
		if (img) return img;
		
		const container = this.zoomContainer.querySelector('.product-zoom-main-media.show');
		if (container && container.style.backgroundImage) return container;
		
		return null;
	}

	handlePanStart(e) {
		if (this.currentZoom <= this.minZoom) return;
		
		e.preventDefault();
		this.isDragging = true;
		this.startX = e.clientX - this.panX;
		this.startY = e.clientY - this.panY;
		this.zoomContainer.style.cursor = 'grabbing';
	}

	handlePanMove(e) {
		if (!this.isDragging || this.currentZoom <= this.minZoom) return;
		
		e.preventDefault();
		this.panX = e.clientX - this.startX;
		this.panY = e.clientY - this.startY;
		
		this.constrainPan();
		this.applyTransform();
	}
	handlePanEnd(e) {
		if (!this.isDragging) return;
		
		this.isDragging = false;
		this.zoomContainer.style.cursor = 'grab';
	}handleWheel(e) {
		e.preventDefault();
		
		const mouseX = e.clientX;
		const mouseY = e.clientY;
		
		const delta = e.deltaY < 0 ? 0.1 : -0.1;
		const newZoom = Math.min(Math.max(this.currentZoom + delta, this.minZoom), this.maxZoom);
		
		this.zoomAtPoint(mouseX, mouseY, newZoom);
	}

	handleDoubleClick(e) {
		e.preventDefault();
		
		const newZoom = this.currentZoom > this.minZoom ? this.minZoom : 2;
		
		if (newZoom === this.minZoom) {
			this.resetZoom();
		} else {
			this.zoomAtPoint(e.clientX, e.clientY, newZoom);
		}
	}

	handleTouchStart(e) {
		e.preventDefault();
		
		this.touches = Array.from(e.touches);
		
		if (this.touches.length === 1) {
			if (this.currentZoom > this.minZoom) {
				this.isDragging = true;
				this.startX = this.touches[0].clientX - this.panX;
				this.startY = this.touches[0].clientY - this.panY;
			}
		} else if (this.touches.length === 2) {
			this.isZooming = true;
			this.lastDistance = this.getDistance(this.touches[0], this.touches[1]);
		}
	}
	handleTouchMove(e) {
		e.preventDefault();
		
		this.touches = Array.from(e.touches);
		
		if (this.touches.length === 1 && this.isDragging) {
			this.panX = this.touches[0].clientX - this.startX;
			this.panY = this.touches[0].clientY - this.startY;
			
			this.constrainPan();
			this.applyTransform();
		} else if (this.touches.length === 2 && this.isZooming) {
			const currentDistance = this.getDistance(this.touches[0], this.touches[1]);
			const scale = currentDistance / this.lastDistance;
			const newZoom = Math.min(Math.max(this.currentZoom * scale, this.minZoom), this.maxZoom);
			
			const centerX = (this.touches[0].clientX + this.touches[1].clientX) / 2;
			const centerY = (this.touches[0].clientY + this.touches[1].clientY) / 2;
			
			this.zoomAtPoint(centerX, centerY, newZoom);
			this.lastDistance = currentDistance;
		}
	}

	handleTouchEnd(e) {
		this.touches = Array.from(e.touches);
		
		if (this.touches.length === 0) {
			this.isDragging = false;
			this.isZooming = false;
		} else if (this.touches.length === 1) {
			this.isZooming = false;
			if (this.currentZoom > this.minZoom) {
				this.isDragging = true;				this.startX = this.touches[0].clientX - this.panX;
				this.startY = this.touches[0].clientY - this.panY;
			}
		}
	}

	getDistance(touch1, touch2) {
		const dx = touch1.clientX - touch2.clientX;
		const dy = touch1.clientY - touch2.clientY;
		return Math.sqrt(dx * dx + dy * dy);	}	zoomAtPoint(clientX, clientY, newZoom) {
		const target = this.getCurrentImage();
		if (!target) return;
				const rect = this.zoomContainer.getBoundingClientRect();
		
		const containerX = clientX - rect.left;
		const containerY = clientY - rect.top;
		
		let imgNaturalWidth, imgNaturalHeight;
		
		const isImgElement = target.tagName === 'IMG';
		
		if (isImgElement) {
			imgNaturalWidth = target.naturalWidth || target.width;
			imgNaturalHeight = target.naturalHeight || target.height;
		} else {
			const targetRect = target.getBoundingClientRect();
			imgNaturalWidth = targetRect.width;
			imgNaturalHeight = targetRect.height;
		}
		
		const containerCenterX = rect.width / 2;
		const containerCenterY = rect.height / 2;
		
		const currentImagePointX = (containerX - containerCenterX - this.panX) / (this.currentZoom * imgNaturalWidth);
		const currentImagePointY = (containerY - containerCenterY - this.panY) / (this.currentZoom * imgNaturalHeight);				this.currentZoom = newZoom;
		
		this.panX = containerX - containerCenterX - (currentImagePointX * this.currentZoom * imgNaturalWidth);
		this.panY = containerY - containerCenterY - (currentImagePointY * this.currentZoom * imgNaturalHeight);
		
		this.constrainPan();
		this.applyTransform();
				
		this.zoomContainer.style.cursor = 'grab';	}	constrainPan() {
		const target = this.getCurrentImage();
		if (!target || this.currentZoom <= this.minZoom) {
			this.panX = 0;
			this.panY = 0;
			return;
		}
				const containerRect = this.zoomContainer.getBoundingClientRect();
		
		const isImgElement = target.tagName === 'IMG';
		let scaledWidth, scaledHeight;
		
		if (isImgElement) {
			const imgRect = target.getBoundingClientRect();
			scaledWidth = imgRect.width * this.currentZoom;
			scaledHeight = imgRect.height * this.currentZoom;
		} else {
			const targetRect = target.getBoundingClientRect();
			scaledWidth = targetRect.width * this.currentZoom;
			scaledHeight = targetRect.height * this.currentZoom;
		}
				
		const maxPanX = Math.max(0, (scaledWidth - containerRect.width) / 2);
		const maxPanY = Math.max(0, (scaledHeight - containerRect.height) / 2);
				// Applica vincoli
		this.panX = Math.max(-maxPanX, Math.min(maxPanX, this.panX));
		this.panY = Math.max(-maxPanY, Math.min(maxPanY, this.panY));	}	applyTransform() {
		const target = this.getCurrentImage();
		if (!target) return;
				const transform = `translate(${this.panX}px, ${this.panY}px) scale(${this.currentZoom})`;
		const transition = this.isDragging || this.isZooming ? 'none' : 'transform 0.2s ease-out';
				
		const isImgElement = target.tagName === 'IMG';
		const isMobileContainer = target.style.backgroundImage && !isImgElement;
		
		if (isImgElement) {
			target.style.transform = transform;
			target.style.transformOrigin = 'center center';
			target.style.transition = transition;
		} else if (isMobileContainer) {
			target.style.transform = transform;
			target.style.transformOrigin = 'center center';
			target.style.transition = transition;
			target.style.backgroundPosition = 'center center';
		}	}
	resetZoom() {
		this.currentZoom = this.minZoom;
		this.panX = 0;
		this.panY = 0;
		this.applyTransform();
		this.zoomContainer.style.cursor = 'grab';	}
	resetPanAndZoom() {
		this.resetZoom();
		this.isDragging = false;
		this.isZooming = false;
		this.touches = [];	}

	cleanupPanAndZoom() {		if (!this.boundPanEvents || !this.zoomContainer) return;
		
		// Rimuovi event listeners
		this.zoomContainer.removeEventListener('mousedown', this.boundPanEvents.mousedown);
		document.removeEventListener('mousemove', this.boundPanEvents.mousemove);
		document.removeEventListener('mouseup', this.boundPanEvents.mouseup);
		this.zoomContainer.removeEventListener('wheel', this.boundPanEvents.wheel);
		this.zoomContainer.removeEventListener('dblclick', this.boundPanEvents.dblclick);		this.zoomContainer.removeEventListener('touchstart', this.boundPanEvents.touchstart);
		this.zoomContainer.removeEventListener('touchmove', this.boundPanEvents.touchmove);
		this.zoomContainer.removeEventListener('touchend', this.boundPanEvents.touchend);
		
		// Reset riferimenti
		this.boundPanEvents = {};
		this.zoomContainer = null;
		this.currentImage = null;
	}
}

customElements.define('cmp-product-image-zoom', CmpProductImageZoom);
